import Vue from 'vue';
import http from '@http';
import moment from 'moment';
import { DateValue } from '@common/types';

let request = null;

function state() {
    return {
        chartData: {},
        mode: 'week',
        chartDate: null,
        loader: false,
    };
}

const getters = {
    chartData: (state) => state.chartData,
    chartMode: (state) => state.mode,
    // TODO: FD-5566
    chartDate: (state) => state.chartDate?.toDate() || new Date(0),
    loader: (state, getters, rootState, rootGetters) => state.loader && !rootGetters.isViewLoading,
};

const mutations = {
    reset(state) {
        Vue.set(state, 'chartData', {});
    },
    setChartData(state, payload) {
        payload.forEach((i) => {
            Vue.set(state.chartData, i.date, {
                due: parseInt(i.due) + parseInt(i.overdue),
                ok: i.ok,
                paused: i.pauseMonitoring,
            });
        });
    },
    setChartMode(state, payload) {
        state.mode = payload;
    },
    setChartDate(state, payload) {
        // TODO: FD-5566 use DataValue type
        state.chartDate = moment(payload);
    },
    setLoader(state, payload) {
        state.loader = payload;
    },
};

const actions = {
    onPlaceChange: {
        root: true,
        handler({ commit }) {
            commit('reset');
        },
    },
    async init({ dispatch }, { date, groupId, mode }) {
        try {
            date && dispatch('setChartDate', { date });
            mode && dispatch('setChartMode', { mode });
            if (groupId) {
                await dispatch('getStatistics', { groupId });
            } else {
                await dispatch('getStatistics');
            }
        } catch (e) {
            console.error(e);
        }
    },
    /**
     * Get statistic for chart
     * @param {Object} payload.
     * @param {number} payload.groupId - Group id.
     * @param {Date} payload.entry.startDate
     * @param {Date} payload.entry.endDate
     */
    async getStatistics({ state, rootGetters, commit, dispatch }, payload) {
        try {
            const now = state.chartDate.clone();
            let startDate, endDate;
            if (state.mode === 'week') {
                startDate = now.clone().startOf('isoWeek').toDate();
                endDate = now.clone().endOf('isoWeek').toDate();
            } else if (state.mode === 'month') {
                startDate = now.set('date', 1).toDate();
                endDate = now.set('date', now.daysInMonth()).toDate();
            }

            let url = `/api/places/${rootGetters.selectedPlaceId}/activity-log/statistics`;

            let query = '';
            if (startDate && endDate) {
                // TODO: FD-5566 use DataValue type
                query = `?startDate=${moment(startDate).locale('en').format('YYYY-MM-DD')}&endDate=${moment(endDate)
                    .locale('en')
                    .format('YYYY-MM-DD')}`;
            }

            if (payload?.groupId) {
                if (query) {
                    query += `&taskSubtypeId=${payload.groupId}`;
                } else {
                    query += `?taskSubtypeId=${payload.groupId}`;
                }
            }

            commit('setLoader', true);

            request?.cancelRequest('Cancel previous');
            request = http.get(`${url}${query}`);
            const pauseDates = await dispatch('getMonitoringPeriodInDates', { startDate, endDate });
            const res = await request;

            if (pauseDates) {
                await res.data.forEach((date) => {
                    date.pauseMonitoring = null;
                    pauseDates.forEach((pause) => {
                        if (date.date >= pause?.start_date && date.date <= pause.end_date) {
                            date.pauseMonitoring = pause;
                        }
                    });
                });
            }

            commit('reset');
            commit('setChartData', res.data);

            commit('setLoader', false);
        } catch (error) {
            console.error(error);

            if (!error.__CANCEL__) {
                commit('setLoader', false);
            }
        }
    },
    /**
     *
     * @param {*} param0
     * @param {*} payload
     */
    async updateStatistic({ dispatch }, payload) {
        try {
            dispatch('getStatistics', payload);
        } catch (error) {
            console.error(error);
        }
    },
    /**
     *
     * @param {*} param0
     * @param {*} payload
     */
    setChartMode({ commit, state }, payload) {
        if (state.mode !== payload.mode) {
            commit('setChartMode', payload.mode);
        }
    },
    /**
     *
     * @param {*} param0
     * @param {*} payload
     */
    setChartDate({ commit, state }, payload) {
        if (!state.chartDate?.isSame(payload.date)) {
            commit('setChartDate', payload.date);
        }
    },

    async getMonitoringPeriodInDates({ rootGetters }, payload) {
        const query = `?fromDate=${new DateValue(payload.startDate).format('YYYY-MM-DD')}&toDate=${new DateValue(
            payload.endDate
        ).format('YYYY-MM-DD')}`;
        const { data } = await http.get(`/api/places/${rootGetters.selectedPlaceId}/monitoring-pause-periods${query}`);
        return data;
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
};
